import * as React from "react";
import Rating from "@mui/material/Rating";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { useLanguage } from "./Language";
import { ReviewService } from "./ReviewService";
import createCache from "@emotion/cache";

interface RateAndReviewProps {
  resourceId?: number;
  averageRating?: number;
  readonly?: boolean;
  onClickReview?: (rating: number) => void;
}

// TODO export a styled rating control to use for read only, or form embedded instances
export function RateAndReview({
  resourceId,
  averageRating = 0,
  readonly = false,
  onClickReview,
}: RateAndReviewProps) {
  const [open, setOpen] = React.useState<boolean>(false);
  const [rating, setRating] = React.useState<number | null>(averageRating);
  const [readOnly, setReadOnly] = React.useState<boolean>(readonly);
  const { translate } = useLanguage();

  const handleClose = () => {
    setOpen(false);
  };

  const handleReview = () => {
    setOpen(false);
    // TODO open review modal
    onClickReview(rating);
  };

  // action will be undefined if ratingOnly is true
  const action = onClickReview && (
    <Button color="inherit" onClick={handleReview} size="small">
      {translate("writeAFullReviewQuestion")}
    </Button>
  );

  const successMessage = translate("ratingHasBeenSaved");

  const handleRatingChange = async (
    event: React.ChangeEvent<{}>,
    newValue: number | null
  ) => {
    if (newValue !== null) {
      // setReadOnly(true);
      try {
        const { success } = await ReviewService.addRating(resourceId, newValue);
        if (!success) {
          // setReadOnly(false);
          return;
        }
        setOpen(true);
        const { average } = await ReviewService.getRatingInformation(
          resourceId
        );
        setRating(average);
      } catch (error) {
        // setReadOnly(false);
        console.error("Error:", error);
      }
    }
  };

  const cache = createCache({
    key: "css",
    prepend: true,
    container: document.body,
  });

  // const shadowRoot = document.getElementById("react-app").shadowRoot;
  // const portalContainer = shadowRoot.getElementById("app-root");
  const portalContainer = document.getElementById("app-root");

  return (
    <div>
      <Rating
        name="rating"
        readOnly={readOnly}
        value={rating}
        onChange={handleRatingChange}
        icon={<StarIcon fontSize="inherit" htmlColor="#d77e02" />}
        emptyIcon={<StarBorderIcon fontSize="inherit" htmlColor="#99948F" />}
        precision={0.5}
      />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={open}
          onClose={handleClose}
          // autoHideDuration={5000}
        >
          <Alert
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
            action={action}
          >
            {successMessage}
          </Alert>
        </Snackbar>
    </div>
  );
}
